export default __webpack_public_path__ + "static/media/amb2.206699f0.png";